(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/expandable-box/assets/javascripts/components/prescript.js') >= 0) return;  svs.modules.push('/components/components/expandable-box/assets/javascripts/components/prescript.js');

(function(svs) {
  svs.components = svs.components || {};
  svs.components.expandableBox = svs.components.expandableBox || {};
})(svs);


 })(window);